/* eslint-disable max-len */
import React from 'react'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import 'moment/locale/en-gb'
import customParseFormat from 'dayjs/plugin/customParseFormat'

export default function CustomDatePicker({
    id,
    classKey,
    format,
    state,
    placeholder,
    handleSelect,
    setdateError,
    termkey,
    disabledDate,
    imageClass,
    disabledFutureDate,
    setToastErrorMessage,
    setsubmitSelected,
    label,
    htmlFor,
    onBlur,defaultValue
}) {
    const rendercustomdate = (current) => {
        return (
            <div classname="ant-calendar-date" title="">
                {current.date()}
            </div>
        );
    }
    return (
        <div className="relative w-full cursor-pointer">
            <label htmlFor={htmlFor} className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
            <DatePicker
                onClick={() => {if (setToastErrorMessage !== undefined){setToastErrorMessage('')}; if(setsubmitSelected !== undefined) {setsubmitSelected(false)}}}
                daterender={(current)=>rendercustomdate(current)}
                className={classKey}
                // disabledDate={(current) =>
                //     disabledFutureDate
                //         ? current && current.valueOf() > Date.now()
                //         : false
                // }
                id={id}
                onBlur={onBlur!==undefined?onBlur:null}
                format={format}
                placeholder={placeholder}
                onChange={(date, dateString) =>
                    handleSelect(id, date, dateString, termkey)
                }
                value={termkey && dayjs(termkey)}
                suffixIcon={
                    
                    <img
                        src="/images/Calender_filter.svg"
                        alt="icon"
                        className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-[-4px] w-[20px] z-[1]"
                    />
                    
                }
                // onFocus={() => setdateError(false)}
                title=""
                defaultValue={defaultValue!==undefined?defaultValue:null}
            />
            {/* <img src="/images/calendar.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] right-[13px]" /> */}
        </div>
    )
}
